var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.144,
    height: 16.92,
    viewBox: "0 0 17.144 16.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3493004081535699799",
    "data-name": 3493004081535700000,
    transform: "translate(-8.755 -9.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M25.529,39.021h3.52v3.522a.316.316,0,0,0,.316.316h1.914a.316.316,0,0,0,.316-.316V39.021h3.52a.316.316,0,0,0,.316-.316V36.792a.316.316,0,0,0-.316-.316h-3.52V32.956a.316.316,0,0,0-.316-.316H29.364a.316.316,0,0,0-.316.316v3.521h-3.52a.316.316,0,0,0-.316.316v1.913A.316.316,0,0,0,25.529,39.021Zm.316-1.913h3.52a.316.316,0,0,0,.316-.316V33.271h1.282v3.521a.316.316,0,0,0,.316.316H34.8v1.281h-3.52a.316.316,0,0,0-.316.316v3.522H29.68V38.705a.316.316,0,0,0-.316-.316h-3.52Z",
    transform: "translate(-12.994 -18.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M25.583,12.066h-2.97A2.759,2.759,0,0,0,20.15,9.289H14.5a2.759,2.759,0,0,0-2.463,2.777H9.071a.316.316,0,0,0-.316.316V25.893a.316.316,0,0,0,.316.316H25.583a.316.316,0,0,0,.316-.316V12.382A.316.316,0,0,0,25.583,12.066ZM14.5,9.92H20.15a2.124,2.124,0,0,1,1.829,2.146h-9.3A2.124,2.124,0,0,1,14.5,9.92ZM25.267,25.577H9.386V12.7H25.267Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.a28a4db2b13ef0273519c55c804dce65.svg";
export { ForwardRef as ReactComponent };